// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-group-component{list-style-type:none;padding:0 20px;margin-bottom:20px}.menu-group-component__title{color:#34495e;font-size:15px;font-weight:500;padding:10px 0}", ""]);
// Exports
module.exports = exports;
